/* eslint-disable @stylistic/max-len */
export const fragSamplerColourMatrix = `
precision highp float;

uniform sampler2D uSampler0;
varying vec2 outTexCoord;

uniform float uColorMatrix[20];
uniform float uAlpha;

// {{colourRegionMaskUniforms}}

void main ()
{
  vec4 texColourToShade = texture2D(uSampler0, outTexCoord);

  // {{colourRegionMaskCheck}}


  // Early out for clear pixels
  if (uAlpha == 0.0)
  {
    gl_FragColor = texColourToShade;
    return;
  }

  if (texColourToShade.a > 0.0)
  {
    texColourToShade.rgb /= texColourToShade.a;
  }

  vec4 result;

  result.r = (uColorMatrix[0] * texColourToShade.r) + (uColorMatrix[1] * texColourToShade.g) + (uColorMatrix[2] * texColourToShade.b) + (uColorMatrix[3] * texColourToShade.a) + uColorMatrix[4];
  result.g = (uColorMatrix[5] * texColourToShade.r) + (uColorMatrix[6] * texColourToShade.g) + (uColorMatrix[7] * texColourToShade.b) + (uColorMatrix[8] * texColourToShade.a) + uColorMatrix[9];
  result.b = (uColorMatrix[10] * texColourToShade.r) + (uColorMatrix[11] * texColourToShade.g) + (uColorMatrix[12] * texColourToShade.b) + (uColorMatrix[13] * texColourToShade.a) + uColorMatrix[14];
  result.a = (uColorMatrix[15] * texColourToShade.r) + (uColorMatrix[16] * texColourToShade.g) + (uColorMatrix[17] * texColourToShade.b) + (uColorMatrix[18] * texColourToShade.a) + uColorMatrix[19];

  vec3 rgb = mix(texColourToShade.rgb, result.rgb, uAlpha);

  rgb *= result.a;

  gl_FragColor = vec4(rgb, result.a);

  // {{colourRegionMaskShade}}
}
`;
